<template>
  <div class="row mx-0 mb-3">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">修改完工回報</div>
      <div style="margin-top: 2rem">
        <commonQueryInput
          :inputItems="multiInputItems"
          v-model:getValue="multiInputVal"
        ></commonQueryInput>
      </div>
      <template v-if="detailData.sourceData.length != 0">
        <div class="d-flex justify-content-end text-end mb-3">
          <div
            class="py-1 px-2"
            style="background: #c8c9ca; min-width: max-content"
          >
            <span>異動人員：{{ username }}</span>
          </div>
        </div>
        <workorderTable
          :workorderItem="detailData.workorderItem"
          class="mb-3"
        />
        <div v-if="detailData.sourceData.length != 0" class="text-start mb-2">
          <template v-for="n in detailData.sourceData.length" :keys="n">
            <button
              class="btn modOrderRecord-order-button me-2 mb-1"
              :class="{ active: buttonSelect == n - 1 }"
              @click="buttonSelect = n - 1"
            >
              {{ n }}
            </button>
          </template>
        </div>
        <orderDataTemplate :userSelectCode="buttonSelect" :modStatus="mod" />
        <div class="text-end mt-3">
          <template v-if="!mod">
            <button
              type="button"
              class="btn p-0"
              style="
                color: #fff;
                background-color: #4b8c80;
                width: 6rem;
                height: 2rem;
                font-size: 1.125rem;
              "
              @click="updateRecord"
            >
              進行修改
            </button>
          </template>
          <template v-if="mod">
            <button
              type="button"
              class="btn p-0 me-2"
              style="
                color: #fff;
                background-color: #4b8c80;
                width: 6rem;
                height: 2rem;
                font-size: 1.125rem;
              "
              @click="updateRecord"
            >
              取消修改
            </button>
            <button
              type="button"
              class="btn p-0"
              style="
                color: #fff;
                background-color: #4b8c80;
                width: 6rem;
                height: 2rem;
                font-size: 1.125rem;
              "
              @click="checkUpdate"
            >
              確認修改
            </button>
          </template>
        </div>
      </template>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonTable from "@/components/commonTable.vue";
import workorderTable from "@/components/orderManagement/orderDataTemplate/table/workorderTable.vue";
import orderDataTemplate from "@/components/orderManagement/orderDataTemplate.vue";
import { computed, inject, provide, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    commonTable,
    workorderTable,
    orderDataTemplate,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const oper = computed(() => store.getters["selectOptions/get_orgProcess"]);

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const username = ref(loginData.value.username);

    const path = inject("path");
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "workCode",
        label: "派工單號",
        type: "text",
        checkEmpty: true,
      },
      {
        key: "oper",
        label: "製程",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇製程 --",
        options: oper,
      },
    ]);

    //人工處理紀錄資訊
    const modOrderRecordOrderData = ref([]);

    const buttonSelect = ref(0);

    const mod = ref(false);
    const orgData = ref([]);

    const detailData = ref({
      operID: "",
      workCode: "",
      sourceData: [],
      workorderItem: [],
    });
    const workCode = ref("");

    const queryOrder = (queryOrderValue) => {
      mod.value = false;
      detailData.value = {
        operID: "",
        workCode: "",
        sourceData: [],
        workorderItem: [],
      };
      methods.triggerLoadingBar();
      modOrderRecordOrderData.value = [];
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "queryOrderData";
      params["workCode"] = queryOrderValue["workCode"];
      params["oper"] = queryOrderValue["oper"];
      workCode.value = queryOrderValue["workCode"];
      let userSelectOper = queryOrderValue["oper"];
      methods.axiosAction(params).then(() => {
        methods.triggerLoadingBar();
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let queryTableData = result.QueryTableData;
          let operID = queryTableData.processSelected;
          let workorderItem = queryTableData.workorderItem;
          let sourceData = queryTableData.sourceData;
          if (operID == 5) {
            sourceData.forEach((data) => {
              data.wireItem.push({
                index: "",
                in_scroll_no: "",
                scroll_no: "",
                orgScroll_no: "",
                code: "",
                chinese_name: "",
                furnaceCode: "",
                in_consumption: "",
                consumption: "",
                orgConsumption: "",
                org_code: "",
                reason: [],
                del: "",
              });
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: "",
              });
            });
          } else if (operID == 6) {
            sourceData.forEach((data) => {
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: "",
              });
            });
          } else if (operID == 7) {
            sourceData.forEach((data) => {
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: "",
              });
            });
          }
          if (sourceData.length == 0) {
            let oper_name = "-";
            oper.value.forEach((data) => {
              if (data.value == userSelectOper) {
                oper_name = data.text;
                return;
              }
            });
            methods.setTimeoutAlert(
              `${workCode.value}在${oper_name}製程無完工資料`
            );
            return;
          }
          detailData.value = {
            operID: operID,
            workCode: workCode.value,
            sourceData: sourceData,
            workorderItem: workorderItem,
          };
        } else {
          methods.setTimeoutAlert(response);
        }
      });
    };

    const updateRecord = () => {
      console.log(mod.value);
      if (!mod.value) {
        methods.triggerLoadingBar();
        var params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = path.value;
        params["methods"] = "POST";
        params["workCode"] = workCode.value;
        params["whichFunction"] = "checkRecord";
        methods.axiosAction(params).then(() => {
          methods.triggerLoadingBar();
          console.log(axiosResult.value);
          let result = axiosResult.value;
          if (result["Response"] == "ok") {
            orgData.value = JSON.parse(
              JSON.stringify(detailData.value.sourceData)
            );
            mod.value = !mod.value;
          } else {
            if (result["Response"] == "online") {
              let oper_name = "-";
              if (result.QueryTableData == "R") {
                oper_name = "打頭";
              } else if (result.QueryTableData == "W") {
                oper_name = "輾牙";
              } else if (result.QueryTableData == "D") {
                oper_name = "熱處理";
              }
              methods.setTimeoutAlert(
                `${workID}正在${oper_name}加工中，欲修改資料請待APP結單`
              );
            } else {
              methods.setTimeoutAlert(result.Response);
            }
          }
        });
      } else {
        detailData.value.sourceData = JSON.parse(JSON.stringify(orgData.value));
        mod.value = !mod.value;
      }
    };
    const checkUpdate = () => {
      console.log(detailData.value.sourceData);
      console.log(orgData.value);
      if (
        JSON.stringify(detailData.value.sourceData) ===
        JSON.stringify(orgData.value)
      ) {
        methods.setTimeoutAlert(`製令無異動，請重新確認`);
        console.log("製令無異動，請重新確認");
        mod.value = !mod.value;
        return;
      }
      // 生產單位/製程/時間/數量/人員異動
      let updateData = [];
      let erro = false;
      detailData.value.sourceData.forEach((data, mainIndex) => {
        data.reasonData = "";
        let wireItem = [];
        console.log(data.wireItem);
        if (data.wireItem != undefined) {
          data.wireItem.forEach((wireItemData, index) => {
            if (index == data.wireItem.length - 1) {
              return;
            }
            if (wireItemData.scroll_no == "") {
              erro = true;
              methods.setTimeoutAlert(`線材捲號尚未輸入`);
              return;
            }
            if (wireItemData.consumption == "") {
              erro = true;
              methods.setTimeoutAlert(`耗用量尚未輸入`);
              return;
            }
            if (wireItemData.reason.length != 0) {
              if (!data.reasonData.includes("線材資料")) {
                data.reasonData += "線材資料/";
              }
            }
            wireItem.push({
              scroll_no: wireItemData.scroll_no,
              code: wireItemData.code,
              chinese_name: wireItemData.chinese_name,
              furnaceCode: wireItemData.furnaceCode,
              consumption: wireItemData.consumption,
              org_code: wireItemData.org_code,
            });
          });
          if (
            data.wireItem.length != orgData.value[mainIndex]["wireItem"].length
          ) {
            if (!data.reasonData.includes("線材資料")) {
              data.reasonData += "線材資料/";
            }
          }
          if (erro == true) {
            return;
          }
        }

        if (data.unit_actual_weight != undefined) {
          if (data.unit_actual_weight == "") {
            erro = true;
            methods.setTimeoutAlert(`單支重尚未輸入`);
            return;
          }
        }
        if (data.reason.length != 0) {
          if (!data.reasonData.includes("單支重")) {
            data.reasonData += "單支重/";
          }
        }

        let runcardItem = [];
        console.log(data.runcardItem);
        if (data.runcardItem != undefined) {
          data.runcardItem.forEach((runcardItemData, index) => {
            if (index == data.runcardItem.length - 1) {
              return;
            }
            if (runcardItemData.runcard_code == "") {
              erro = true;
              methods.setTimeoutAlert(`流程卡號尚未輸入`);
              return;
            }
            if (runcardItemData.furnace_code == "") {
              erro = true;
              methods.setTimeoutAlert(`爐號尚未輸入`);
              return;
            }
            if (runcardItemData.screw_weight == "") {
              erro = true;
              methods.setTimeoutAlert(`重量尚未輸入`);
              return;
            }
            if (runcardItemData.bucket_weight == "") {
              erro = true;
              methods.setTimeoutAlert(`桶重尚未輸入`);
              return;
            }
            if (runcardItemData.reason.length != 0) {
              if (!data.reasonData.includes("生產重量")) {
                data.reasonData += "生產重量/";
              }
            }
            runcardItem.push({
              runcard_code: runcardItemData.runcard_code,
              furnace_code: runcardItemData.furnace_code,
              screw_weight: runcardItemData.screw_weight,
              bucket_weight: runcardItemData.bucket_weight,
            });
          });
          if (
            data.runcardItem.length !=
            orgData.value[mainIndex]["runcardItem"].length
          ) {
            if (!data.reasonData.includes("生產重量")) {
              data.reasonData += "生產重量/";
            }
          }
          if (erro == true) {
            return;
          }
        }

        let totalProduceTimeItem = [];
        data.totalProduceTimeItem.forEach((totalProduceTimeItemData) => {
          if (totalProduceTimeItemData.device_name == "") {
            erro = true;
            methods.setTimeoutAlert(`機台編號尚未輸入`);
            return;
          }
          if (totalProduceTimeItemData.reason.length != 0) {
            if (!data.reasonData.includes("生產機台")) {
              data.reasonData += "生產機台/";
            }
          }
          totalProduceTimeItem.push({
            code: totalProduceTimeItemData.code,
            device_name: totalProduceTimeItemData.device_name,
            startTime: totalProduceTimeItemData.startTime,
            endTime: totalProduceTimeItemData.endTime,
            totalTime: totalProduceTimeItemData.totalTime,
          });
        });
        if (erro == true) {
          return;
        }

        if (data.reasonData != "") {
          data.reasonData = data.reasonData.substring(
            0,
            data.reasonData.length - 1
          );
          data.reasonData += "異動";

          updateData.push({
            workorderBind: data.workorderBind,
            wireItem: wireItem,
            unit_actual_weight: data.unit_actual_weight,
            runcardItem: runcardItem,
            totalProduceTimeItem: totalProduceTimeItem,
            reason: data.reason,
            reasonData: data.reasonData,
          });
        }
      });

      if (erro == true) {
        return;
      }

      if (updateData.length == 0) {
        methods.setTimeoutAlert(`製令無異動，請重新確認`);
        console.log("製令無異動，請重新確認");
        mod.value = !mod.value;
        return;
      }

      console.log(updateData);
      console.log("有異動");
      methods.triggerLoadingBar();
      var params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      params["methods"] = "POST";
      params["data"] = updateData;
      params["changeUser"] = loginData.value.account;
      params["whichFunction"] = "updateCompleteOrder";
      methods.axiosAction(params).then(() => {
        methods.triggerLoadingBar();
        let result = axiosResult.value;
        if (result["Response"] == "ok") {
          let workCode = result.QueryTableData.work_code;
          let operSelected = result.QueryTableData.project_id;
          queryOrder({ workCode: workCode, oper: operSelected });
        } else {
          methods.setTimeoutAlert(`異常，請再次確認`);
          return;
        }
      });
    };

    const query_detailData = (
      workCode,
      oper,
      deviceName,
      workEndTime,
      transTimes
    ) => {
      detailData.value = {
        operID: "",
        workCode: "",
        sourceData: [],
        workorderItem: [],
      };
      console.log(workCode, oper, deviceName, workEndTime, transTimes);
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "queryOrderData";
      params["work_code"] = workCode;
      params["project_id"] = oper;
      params["device_name"] = deviceName;
      params["work_end_time"] = workEndTime;
      params["trans_times"] = transTimes;
      params["whichFunction"] = "modOrderRecordDetail";

      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        methods.triggerLoadingBar();
        if (response == "ok") {
          let operID = result.QueryTableData.processSelected;
          let workorderItem = result.QueryTableData.workorderItem;
          let sourceData = result.QueryTableData.sourceData;
          if (operID == 5) {
            sourceData.forEach((data) => {
              data.wireItem.push({
                index: "",
                in_scroll_no: "",
                scroll_no: "",
                orgScroll_no: "",
                code: "",
                chinese_name: "",
                furnaceCode: "",
                in_consumption: "",
                consumption: "",
                orgConsumption: "",
                org_code: "",
                reason: [],
                del: "",
              });
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: "",
              });
            });
          } else if (operID == 6) {
            sourceData.forEach((data) => {
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: "",
              });
            });
          } else if (operID == 7) {
            sourceData.forEach((data) => {
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: "",
              });
            });
          }
          if (sourceData.length == 0) {
            methods.setTimeoutAlert("查無資料");
            return;
          }
          detailData.value = {
            operID: operID,
            workCode: workCode,
            sourceData: sourceData,
            workorderItem: workorderItem,
          };
        } else {
          methods.setTimeoutAlert(response);
        }
      });
    };

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        queryOrder(newValue);
      },
      { deep: true }
    );
    watch(buttonSelect, (newValue) => {
      // modOrderRecordItems.value = modOrderRecordOrderData.value[newValue - 1];
    });

    provide("orderManagementDetailData", detailData);
    return {
      username,
      multiInputVal,
      multiInputItems,
      modOrderRecordOrderData,
      buttonSelect,
      mod,
      detailData,
      updateRecord,
      checkUpdate,
      query_detailData,
    };
  },
};
</script>

<style scoped>
.modOrderRecord-button {
  width: 53px;
  height: 22px;
  line-height: 22px;
  padding: 0px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  border: 0px;
}

.modOrderRecord-button:hover {
  color: var(--main-font-color);
}

.modOrderRecord-order-button {
  height: 2rem;
  padding: 0;
  width: 4.25rem;
  color: var(--main-font-color);
  background-color: var(--main-status-secondary-color);
  border-color: var(--main-status-secondary-color);
}

.modOrderRecord-order-button:hover {
  color: var(--main-font-color);
}

.modOrderRecord-order-button.active {
  background-color: var(--main-bg-color);
  border-color: var(--main-bg-color);
}
</style>